import pdflogo from "../Assets/Svg/pdf-icon.svg";
import jpglogo from "../Assets/Svg/jpg-icon.svg";
import imagelogo from "../Assets/Svg/image_logo.svg";
import wordLogo from "../Assets/Svg/word_logo.svg";
import powerPointLogo from "../Assets/Svg/powerpoint_logo.svg";
import excelLogo from "../Assets/Svg/excel_logo.svg";

export const getFileIcon = (fileName, fileType) => {
  const extension = fileName.toLowerCase().split('.').pop();
  
  // PDF files
  if (fileType === "application/pdf" || extension === 'pdf') {
    return pdflogo;
  }
  
  // Word files
  if (fileType === "application/msword" || 
      fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      extension === 'doc' || extension === 'docx') {
    return wordLogo;
  }
  
  // Excel files
  if (fileType === "application/vnd.ms-excel" || 
      fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      extension === 'xls' || extension === 'xlsx' || extension === 'csv') {
    return excelLogo;
  }
  
  // PowerPoint files
  if (fileType === "application/vnd.ms-powerpoint" || 
      fileType === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
      extension === 'ppt' || extension === 'pptx') {
    return powerPointLogo;
  }
  
  if  (['jpg'].includes(extension)) {
    return jpglogo;
  }
  
  return imagelogo;
};